import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <footer className="footer ttm-bgcolor-darkgrey ttm-textcolor-white clearfix">
        <div className="second-footer ttm-bgcolor-darkgrey ttm-bgimage-yes ttm-bg">
          <div className="ttm-row-wrapper-bg-layer ttm-bg-layer" />
          <div className="container">
            <div className="row">
              {/* Section 1: Logo & About */}
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 widget-area">
                <div className="widget widget_text clearfix">
                  <div className="footer-logo">
                    <img
                      id="footer-logo-img"
                      className="img-center"
                      src={`${process.env.PUBLIC_URL}/assets/images/footer-logo.png`}
                      alt="MetaMind Footer Logo"
                    />
                  </div>
                  <div className="textwidget widget-text">
                    <p className="pb-10 pr-30 res-575-pr-0">
                      We provide high-quality translation services with accuracy, consistency, and industry-specific expertise to support your global communication needs.
                    </p>
                  </div>
                </div>
              </div>

              {/* Section 2: Quick Links */}
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-2 widget-area">
                <div className="widget widget_nav_menu clearfix">
                  <h3 className="widget-title">Quick Links</h3>
                  <ul id="menu-footer-quicklinks">
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/about-us">About</Link></li>
                    <li><Link to="/services">Services</Link></li>
                    <li><Link to="/language">Language</Link></li>
                    <li><Link to="/industry">Industry</Link></li>
                    <li><Link to="/contact-us">Contact</Link></li>
                  </ul>
                </div>
              </div>

              {/* Section 3: Our Services (simple list matching Quick Links) */}
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 widget-area">
                <div className="widget widget_nav_menu clearfix">
                  <h3 className="widget-title">Our Services</h3>
                  <ul id="menu-footer-quicklinks">
                    <li><Link to="/services">Content Writing</Link></li>
                    <li><Link to="/services">Website Localization</Link></li>
                    <li><Link to="/services">Voiceover &amp; Subtitling</Link></li>
                    <li><Link to="/services">Software Localization</Link></li>
                    <li><Link to="/services">Translation Services</Link></li>
                    <li><Link to="/services">DTP Services</Link></li>
                  </ul>
                </div>
              </div>

              {/* Section 4: Contact Info */}
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 widget-area">
                <div className="widget widget_text clearfix">
                  <h3 className="widget-title">Contact Info</h3>
                  <ul className="widget_contact_wrapper">
                    <li>
                      <i className="ttm-textcolor-skincolor fa fa-phone" />
                      <div><h6>Phone:</h6>9876552511</div>
                    </li>
                    <li>
                      <i className="ttm-textcolor-skincolor fa fa-envelope-o" />
                      <div><h6>Email:</h6><a href="mailto:info@metamindinc.com">info@metamindinc.com</a></div>
                    </li>
                    <li>
                      <i className="ttm-textcolor-skincolor fa fa-map-marker" />
                      <div><h6>Address:</h6>Sector 50, Noida,<br />Uttar Pradesh 201303</div>
                    </li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="bottom-footer-text ttm-bgcolor-darkgrey">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="copyright text-center">
                  <span>Copyright © 2025 Meta Mind Inc. All rights reserved.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* back-to-top start */}
      <a id="totop" href="#top">
        <i className="fa fa-angle-up" />
      </a>
      {/* back-to-top end */}
    </>
  );
}

export default Footer;